import { RouteConfig } from "vue-router";
import { RDocument } from "@/components/DocumentViewCards/RDocument";
import { RCompanyDocumentsBrowse } from "@/pages/Layout/views/Expert/views/Companies/template/views/Documents/Browse/RCompanyDocumentsBrowse";
import { RUploadDocuments } from "@/modules/Documents/Upload/RUploadDocuments";

export const RCompanyDocuments: RouteConfig = {
  path: "documents",
  component: () =>
    import(
      /* webpackChunkName: "companies-template-company-documents" */
      "./VCompanyDocuments.vue"
    ),
  meta: {
    label: "documents",
    title: "Companies",
  },
  children: [RCompanyDocumentsBrowse, RDocument, RUploadDocuments],
};
